(function () {
  if (window.AlvaShipping) return;
  const DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const eastern = new Intl.DateTimeFormat('en-US', {timeZone:'America/New_York',year:'numeric',month:'numeric',day:'numeric',hour:'numeric',minute:'numeric',second:'numeric',hourCycle:'h23'});
  function nextBusinessDay(date) {
    const next = new Date(date);
    do {next.setUTCDate(next.getUTCDate()+1);} while ([0,6].includes(next.getUTCDay()));
    return next;
  }
  function calculate(now = new Date()) {
    const p = {};
    eastern.formatToParts(now).forEach(part => {if(part.type !== 'literal')p[part.type]=Number(part.value);});
    const today = new Date(Date.UTC(p.year,p.month-1,p.day));
    const beforeCutoff = ![0,6].includes(today.getUTCDay()) && p.hour < 13;
    const ship = beforeCutoff ? today : nextBusinessDay(today);
    const minutes = beforeCutoff ? Math.ceil((13*3600-p.hour*3600-p.minute*60-p.second)/60) : 0;
    const hours = Math.floor(minutes/60);
    const remaining = (hours ? hours+'h ' : '')+(minutes%60)+'m';
    const tomorrow = new Date(today);tomorrow.setUTCDate(tomorrow.getUTCDate()+1);
    const dispatch = beforeCutoff ? 'today' : ship.getUTCDay() === 1 ? 'Monday' : ship.getTime() === tomorrow.getTime() ? 'tomorrow' : DAYS[ship.getUTCDay()];
    let start = ship, end = ship;
    for(let i=0;i<5;i++){end=nextBusinessDay(end);if(i===1)start=end;}
    const eta = MONTHS[start.getUTCMonth()]+' '+start.getUTCDate()+'–'+(start.getUTCMonth()===end.getUTCMonth() ? '' : MONTHS[end.getUTCMonth()]+' ')+end.getUTCDate();
    return {beforeCutoff,minutes,remaining,eta,line:'Ships '+dispatch,order:beforeCutoff ? 'Order in '+remaining+' to ship today' : 'Ships '+dispatch};
  }
  const subscribers = new Set();let timer;
  function notify(){if(document.hidden)return;let result;try{result=calculate();}catch(error){return;}subscribers.forEach(callback => {try{callback(result);}catch(error){console.error('Shipping estimate unavailable',error);}});}
  function sync(){clearInterval(timer);timer=undefined;if(!subscribers.size || document.hidden)return;notify();timer=setInterval(notify,15000);}
  window.AlvaShipping = {calculate,subscribe(callback){subscribers.add(callback);if(subscribers.size===1)sync();else if(!document.hidden){try{callback(calculate());}catch(error){}}return () => {subscribers.delete(callback);if(!subscribers.size){clearInterval(timer);timer=undefined;}};}};
  document.addEventListener('visibilitychange',sync);
  window.addEventListener('focus',notify);
  window.addEventListener('pageshow',sync);
  window.addEventListener('pagehide',()=>{clearInterval(timer);timer=undefined;});
})();
